import { DeliveryAddress, DeliveryType, TransportCompany } from '@/modules/organizations/types';
import { ProductShared } from '@/modules/products/shared/types';
import { BaseMutations } from '@/store/base-mutations';
import { PaginationProps, TableOptions, WareHouse } from '@/types';
import { CatalogRequestFilters } from '@/modules/products/types';
import {
  Cart, CartOrganization, DelLine, CartFileUploadData, CartProject, CartFilters,
} from '../types';
import CartState from './state';

export default class CartMutations extends BaseMutations<CartState> {
  SET_CART(cart: Cart.CartItem[]) {
    this.state.carts_products = cart;
  }

  SET_ITEMS_WITHOUT_ACCREDITATION(data: Cart.CartItem[]) {
    this.state.items_without_accreditation = data;
  }

  TOGGLE_LOADING_CART(toggle: boolean) {
    this.state.cart_loading = toggle;
  }

  SET_CART_TOTAL(data: Cart.CartTotal) {
    this.state.total_info = data;
  }

  UPD_QTY_CART_ITEM({ id, quantity }: Cart.UpdateCartDTO) {
    const idx = this.state.carts_products.findIndex((prod) => prod.id === id);

    if (idx >= 0) {
      this.state.carts_products[idx].quantity = quantity;
    }
  }

  SET_CART_SEARCH(prods: ProductShared[]) {
    this.state.cart_search_items = prods;
  }

  UPD_CART_SEARCH_ITEM_QTY({ key, value, idx }: { key: keyof ProductShared, value: unknown, idx: number }) {
    this.state.cart_search_items[idx][key] = value;
  }

  SET_DL_PLACES_SEARCH(val: string) {
    this.state.dl_places_search = val;
  }

  SET_WAREHOUSES(items: WareHouse[]) {
    this.state.warehouses = items;
  }

  SET_DELIVERY_ADDRESSES(delivery_addresses: DeliveryAddress[]) {
    this.state.delivery_addresses = delivery_addresses;
  }

  SET_DELIVERY_TYPES(delivery_types: DeliveryType[]) {
    this.state.delivery_types = delivery_types;
  }

  SET_TRANSPORT_COMPANIES(companies: TransportCompany[]) {
    this.state.transport_companies = companies;
  }

  SET_ORGANIZATIONS(orgs: CartOrganization[]) {
    this.state.organizations = orgs;
  }

  SET_DOC_TEMPLATE_LINK(path: string) {
    this.state.doc_template_link = path;
  }

  SET_DL_PLACES(places: DelLine.DelLinePlace[]) {
    this.state.dl_places = places;
  }

  SET_DL_TERMINALS(terminals: DelLine.DelLineTerminal[]) {
    this.state.dl_terminals = terminals;
  }

  SET_FILE_UPLOAD_DETAILS(data: CartFileUploadData) {
    this.state.file_upload_details = data;
  }

  // SET_PROJECT_CHOISE(value: boolean) {
  //   this.state.project_choosen = value;
  // }

  SET_PROJECT_CHOOSEN(value: number | null) {
    this.state.project_choosen = value;
  }

  SET_PREVIOUS_PROJECT(value: number | null) {
    this.state.previous_project = value;
  }

  SET_PROJECTS(projects: CartProject[]) {
    this.state.cart_projects = projects;
  }

  UPDATE_LICENSE_DIALOG({ key, value }: { key: keyof Cart.EditLicenseDialog, value: unknown }) {
    this.state.edit_license_dialog[key] = value;
  }

  UPDATE_CURRENT_LICENSE_KEYS(value: string[]) {
    this.state.edit_license_dialog.item.product.license_keys = value;
  }

  UPDATE_SEARCH_KEY(value: string) {
    this.state.search_key = value;
  }

  UPDATE_LICENSE_KEY(items: Cart.CartItem[]) {
    this.state.carts_products = [...items];
  }

  TOGGLE_DELIVERY_LOADING(value: boolean) {
    this.state.delivery_loading = value;
  }

  UPDATE_COUTER_LOADING(isCounterLoading: boolean) {
    this.state.isCounterLoading = isCounterLoading;
  }

  UPD_DELETE_DIALOG({ key, value }: { key: keyof Cart.DeleteDialog, value: unknown }) {
    this.state.delete_dialog[key] = value;
  }

  CLEAR_DELETE_DIALOG() {
    this.state.delete_dialog.visible = false;
    this.state.delete_dialog.type = '';
    this.state.delete_dialog.selected_products = [];
    this.state.delete_dialog.is_last_element = false;
  }

  CLEAR_TOTAL_PRICE() {
    this.state.total_info.prices.nds_value = 0;
    this.state.total_info.prices.no_nds_value = 0;
  }

  UPDATE_ACCR_DIALOG({ key, value }: { key: keyof Cart.AccreditationDialog, value: unknown }) {
    this.state.accreditation_dialog[key] = value;
  }

  CLEAR_ACCR_DIALOG() {
    this.state.accreditation_dialog.visible = false;
    this.state.accreditation_dialog.selected_products = [];
    this.state.accreditation_dialog.loading = false;
  }

  SET_ACCREDITATION_POPUP_MESSAGE(value: string | null) {
    if (value !== null) {
      this.state.accreditation_popup_message = value;
    }
  }

  CLEAR_ACCREDITATION_POPUP_MESSAGE() {
    this.state.accreditation_popup_message = null;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof CartFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  TOGGLE_ADDED_PROD_TO_CARD(value: boolean) {
    this.state.added_prod_to_cart = value;
  }

  TOGGLE_ACCREDITATION_MESSAGE_DIALOG(value: boolean) {
    this.state.accreditation_message_dialog = value;
  }

  SET_NOT_ADDED_PRODUCTS_IDS(ids: string[]) {
    this.state.not_added_product_ids = ids;
  }

  SET_IS_CASH_REGISTERS_AUTO_ADDITION(value: boolean) {
    this.state.is_cash_registers_auto_addition = value;
  }

  SET_IS_DISABLE_BTN(value: boolean) {
    this.state.is_disable_btn = value;
  }

  TOGGLE_IS_OPEN_CART(value: boolean) {
    this.state.is_open_cart = value;
  }

  SET_REALIZATION_CONTRACT_DIALOG(value: boolean) {
    this.state.realization_contract_dialog = value;
  }

  SET_IS_NOT_ADDED_PRODUCTS_MODAL(value: boolean) {
    this.state.is_not_added_product_modal = value;
  }

  SET_IS_NOT_ADDED_PRODUCT_MESSAGE(value: string) {
    this.state.is_not_added_product_message = value;
  }

  SET_CATALOG_PRODUCTS_TABLE_OPTIONS(opts: TableOptions) {
    this.state.catalog_products_table_options = opts;
  }

  UPD_CATALOG_PRODUCTS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.catalog_products_table_options[key] = value;
  }

  UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.catalog_products_pagination_props[key] = value;
  }

  SET_CATALOG_PRODUCTS(catalog_products: Cart.CatalogProduct[]) {
    this.state.catalog_products = catalog_products;
  }

  SET_CATALOG_PRODUCTS_LOADING(value: boolean) {
    this.state.catalog_products_loading = value;
  }

  UPD_CATALOG_PRODUCT_FILTER_KEY({ key, value }: { key: keyof CatalogRequestFilters, value: unknown }) {
    this.state.catalog_products_filters[key] = value;
  }

  CLEAR_CATALOG_PRODUCTS() {
    this.state.catalog_products = [];
  }
}
